<template>
  <div class="physical-dimensions-wrapper">
    <ul
      class="physical-dimensions"
      v-if="jewel.weight || jewel.width || jewel.height"
    >
      <li v-if="jewel.weight">
        <div>
          <span>Вес</span>
        </div>
        <div
          itemprop="weight"
          itemscope itemtype="http://schema.org/QuantitativeValue"
        >
          <meta itemprop="unitCode" content="GRM">
          <span itemprop="value">{{ jewel.weight }}</span>
          <span itemprop="unitText">гр</span>.
      </div>
      </li>
      <li v-if="jewel.width">
        <div>
          <span>Ширина</span>
        </div>
        <div
          itemprop="width"
          itemscope itemtype="http://schema.org/QuantitativeValue"
        >
          <meta itemprop="unitCode" content="MMT">
          <span itemprop="value">{{ jewel.width }}</span>
          <span itemprop="unitText">мм</span>.
        </div>
      </li>
      <li v-if="jewel.height">
        <div>
          <span>Высота</span>
        </div>
        <div
          itemprop="height"
          itemscope itemtype="http://schema.org/QuantitativeValue"
        >
          <meta itemprop="unitCode" content="CMT">
          <span itemprop="value">{{ jewel.height }}</span>
          <span itemprop="unitText">см</span>.
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'CatalogJewelArticleDescriptionPhysicalDimensions',
  props: ['jewel'],
  data: function () {
    return {}
  }
}
</script>

<style scoped lang="scss">
  .physical-dimensions-wrapper {
    margin-bottom: 2em;

    & > .physical-dimensions {
      margin: 0;

      & > li {
        display: inline-block;
        min-width: 80px;
        margin: 0;

        & > :first-child {
          color: $default-heading-color;
          text-transform: uppercase;
          font-family: "Gotham Pro Regular", $font-stack;
          margin-bottom: 1em;

          & > span {
            border-bottom: 1px solid;
            @include media(">mobile") {
              padding: 0 1em 0.25em 0;
            };
            @include media("<=mobile") {
              padding: 0 1em 0.25em 1em;
            };
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/catalog-jewel-article/catalog-jewel-article-description/CatalogJewelArticleDescriptionPhysicalDimensions.vue